export class FetchError extends Error {
  constructor(readonly fetchError: Error) {
    super(`Fetch error: "${fetchError.message}"`);
  }
}
